<template>
  <!-- 活动管理 -->
  <div class="activityListbox">
    <div class="activityManage" v-if="createStep == 1">
      <div class="topbox">
        <div>活动列表</div>
      </div>
      <!-- 头部表单查询 -->
      <input-form ref="inputForm" :btnPosition1="true" :inputData="inputData" :pageName="pageName" @toParentVal="searchForm"></input-form>
      <div class="tabSwitch">
        <div
          class="tabSwitch-wz"
          @click="handleTab(index)"
          v-for="(item, index) in tabSwitchList"
          :key="index"
          :class="{ active: index == currIndex }"
        >
          {{ item }}
        </div>
      </div>
      <!-- 表格内容 -->
      <el-table
        :data="activityList"
        v-loading="talbeLoading"
        style="width: 100%; margin-top: 20px"
        ref="table"
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template slot="empty">
          <div>
            <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column label="活动名称" width="280" prop="activityName"> </el-table-column>

        <el-table-column label="活动类型">
          <template slot-scope="scope">
            <span> {{ activityName(scope.row.activityType) }} </span>
          </template>
        </el-table-column>

        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <div class="activityTime">
              <span>起: {{ scope.row.startTime }}</span>
              <span>止: {{ scope.row.endTime }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="最后修改时间" prop="updateTime"> </el-table-column>
        <el-table-column label="活动状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="state y1">未开始 </span>
            <span v-if="scope.row.status == 2" class="state y2">进行中 </span>
            <span v-if="scope.row.status == 3" class="state y3">已结束 </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <div class="editList">
              <span @click="extension(scope.row)" class="edit">
                推广
              </span>
              <span @click="modify(scope.row.activityType, scope.row, 'look')" class="edit">
                查看
              </span>
              <!-- <span v-if="scope.row.status == 1" @click="modify(scope.row.activityType, scope.row)" class="edit">
                修改
              </span> -->
              <!-- && ![10,9,29,30,13,14,15].includes(Number(scope.row.activityType))) -->
              <template v-if="scope.row.activityType == 35">
                <span v-if="scope.row.status == 1" @click="modify(scope.row.activityType, scope.row,'edit')" class="edit">
                  修改
                </span>
                <span>-</span>
              </template>
              <template v-else>
                <span v-if="scope.row.status == 1 || scope.row.status == 2 " @click="modify(scope.row.activityType, scope.row,'edit')" class="edit">
                  修改
                </span>
                <span v-if="scope.row.status == 3">-</span>
              </template>
              <span v-if="scope.row.status == 2" @click="endenActivity(scope.row.id)" class="end">结束</span>
              <span @click="statisData(scope.row)" class="count">数据统计</span>
              <span @click="modify(scope.row.activityType, scope.row, 'copy')" class="edit">
                复制
              </span>
              <span @click="deleteActivity(scope.row)" class="delete">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="recordData.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="recordData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        class="pagination"
      >
      </el-pagination>
    </div>

    <statistics v-if="createStep == 3" @returnStep="returnStep" :rowData="rowData" :ids1="ids1"></statistics>

    <div class="activityManage" v-if="createStep == 2" style="padding-top: 4px;">
      <createAct @goBack="createStep = 1" :copyParams="copyParams"></createAct>
    </div>

    <!-- 结束活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否结束活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisibleTwo" width="400px" :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 活动推广 -->
    <el-dialog title="活动推广" :modal-append-to-body="false" :visible.sync="CodeVisible" width="800px">
      <div class="activityName">
        <p style="margin-bottom: 20px;text-align: center;">
          请用手机淘宝APP扫描下面二维码查看您店铺的活动详情
        </p>
        <div class="qrcode" id="qrcodebox" ref="qrcodebox" style="width: 300px;height: 300px;margin: 0 auto;"></div>
        <div style="width: 375px;margin: 0 auto;">
          <p style="margin: 20px 0;text-align: center;">
            访问链接:(用于装修到店铺的链接)
          </p>
          <el-input readonly v-model="coodeItem.activityUrl" style="margin: 0 20px; width: 220px"></el-input
          ><el-button type="primary" v-clipboard:copy="coodeItem.activityUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
            >复制</el-button
          >
        </div>
        <template>
          <div class="activityName_line"></div>
          <div class="activityName_title">可通过以下方式推广活动</div>
          <div class="activityName_bottom">
            <div class="activityName_bottom_content">
              <span class="activityName_bottom_wz">直播动态部件</span>
              <div class="display:flex">
                <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
                <span class="activityName_bottom_tg" @click="handlejc(1)">去推广</span>
              </div>
            </div>
            <div class="activityName_bottom_content">
              <span class="activityName_bottom_wz">直播模块装修</span>
              <div class="display:flex">
                <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
                <span class="activityName_bottom_tg" @click="handlejc(2)">去推广</span>
              </div>
            </div>
            <div class="activityName_bottom_content">
              <span class="activityName_bottom_wz">手淘首页海报装修</span>
              <div class="display:flex">
                <span class="activityName_bottom_jc" @click="handlejc(5)">看教程</span>
                <span class="activityName_bottom_tg" @click="handlejc(3)">去推广</span>
              </div>
            </div>
            <div class="activityName_bottom_content">
              <span class="activityName_bottom_wz">会员中心页装修</span>
              <div class="display:flex">
                <span class="activityName_bottom_jc pointer" @click="handlejc(5)">看教程</span>
                <span class="activityName_bottom_tg pointer" @click="handlejc(4)">去推广</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="CodeVisible = false">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import pointsTaskActivity from "./points_task_activity";
import createInviteStep from "./points_task_Invite";
import createActivityStep from "./create_activity_step";
import createActivityStep2 from "./create_activity_step2";
import statistics from "./activity_data_statistics";
import createTaskElectric from "./points_task_electric.vue";
import createTaskPolite from "./points_task_polite.vue";
import createTaskEvaluation from "./points_task_evaluation.vue";
import pointsTaskGames from "./points_task_games.vue";
import createAct from "../huodongedit/index.vue";

import { queryActivity, endEvent, deleteEvent } from "@/api/activityController";
export default {
  components: {
    inputForm,
    pointsTaskActivity,
    createActivityStep,
    createActivityStep2,
    createInviteStep,
    statistics,
    createTaskElectric,
    createTaskPolite,
    createTaskEvaluation,
    pointsTaskGames,
    createAct,
  },
  data() {
    return {
      coodeItem: {
        activityUrl: "",
      },
      isCopy: false,
      copyParams: {},
      CodeVisible: false,
      actManag: 1,
      titlName: "",
      tabSwitchList: ["全部", "进行中", "未开始", "已结束"],
      currIndex: 0,
      backgroundOpacity: false,
      statusComment: false,
      isSave: true,
      pageName: "忠诚度管理-积分-活动管理",
      talbeLoading: false,
      qrcode: null,
      outerVisible: false,
      outerVisibleTwo: false,
      valueRow: {},
      createVal: 0,
      activityDataTwo: {
        telImg: require("../../assets/images/integralCenter/night_m.png"),
        telCode: require("../../assets/images/integralCenter/code.png"),
        id: 1,
        name: "幸运大抽奖",
      },
      activityData: {},
      createStep: 1,
      activityList: [],
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },
        {
          name: "活动类型:",
          val: "activityType",
          placeholder: "请选择活动类型",
          selectArr: [
            { label: "全部", id: null },
            { label: "签到赢好礼", id: 1 },
            // { label: "浏览商品有礼", id: 2 },
            { label: "每日抢好礼", id: 3 },
            { label: "关注店铺有礼", id: 4 },
            { label: "邀请开卡有礼", id: 5 },
            { label: "邀请关注店铺有礼", id: 6 },
            { label: "完善信息有礼", id: 7 },
            { label: "裂变神券", id: 21 },
            { label: "天降红包雨", id: 22 },
            { label: "入会打榜", id: 25 },
            { label: "幸运抽签", id: 26 },
            { label: "0元试用", id: 27 },
          ],
        },
        {
          name: "活动时间:",
          myDate: true,
          noInitValue: true, // 不用给初始化值
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      inputData2: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
        },

        {
          name: "活动时间:",
          noInitValue: true,
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startUpdateTime", "endUpdateTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          // isdefault:true,
        },
      ],
      currentPage: 1,
      totalNum: 0,
      recordData: {
        size: 10,
        current: 1,
      },
      rowData: {},
      ids: "",
      ids1: "",
      activityUrl: "",
      venderId: "",
      aaa: "",
      status: 1,
      mytimestart: "",
      mytimeend: "",
      opentime: true,
    };
  },

  mounted() {
    console.log(this.$route, 6666);
    console.log(this.$route.path.indexOf("activeList3") > -1);
    this.selectList();
    this.queryList();
  },
  created(){
    let secondaryMenuName = "";
    switch(this.$route.name){
      case "activeList": secondaryMenuName="关注拉粉"; break;
      case "activeList1": secondaryMenuName="无线营销"; break;
      case "activeList2": secondaryMenuName="趣味抽奖"; break;
      case "activeList3": secondaryMenuName="游戏中心"; break;
    }
    console.log(secondaryMenuName, "活动列表")
    this.buriedPoint(1, "云起互动", secondaryMenuName, "活动列表");
  },
  methods: {
    handlejc(type) {
      if (type == 1) {
        window.open(
          "https://market.m.taobao.com/app/taefed/shopping-delivery-wapp/index.html#/putin?tabKey=all&appId=3000000075963142&spm=a21dvs.27050869.0.27050869.311514a0Av8jPb",
          "_blank"
        );
      }
      if (type == 2) {
        window.open(
          "https://market.m.taobao.com/app/taefed/shopping-delivery-wapp/index.html#/putin?tabKey=all&appId=3000000075963142&spm=a21dvs.27050869.0.27050869.311514a0Av8jPb",
          "_blank"
        );
      }
      if (type == 3) {
        window.open("https://myseller.taobao.com/home.htm/mobiledecorate", "_blank");
      }
      if (type == 4) {
        window.open("https://ecrm.taobao.com/p/member/memberDecorateLightShop.htm#/", "_blank");
      }
      if (type == 5) {
        window.open("https://www.yuque.com/docs/share/96cfa344-785f-4a43-8ffe-3bdd19e44d78?#", "_blank");
      }
    },
    selectList() {
      if (this.$route.path.indexOf("activeList1") > 1) {
        this.actManag = 2;
        this.inputData[1].selectArr = [
          { label: "全部", id: null },
          { label: "下单有礼", id: 16 },
          { label: "首购有礼", id: 17 },
          { label: "复购有礼", id: 18 },
          { label: "下单抽奖", id: 19 },
          { label: "调查问卷", id: 31 },
          { label: "生日有礼", id: 32 },
          { label: "积分兑换", id: 33 },
          { label: "满额有礼", id: 34 },
          { label: "下单冲榜", id: 35 },
          { label: "会员升级礼", id: 37 }
        ];
      }
      if (this.$route.path.indexOf("activeList2") > 1) {
        this.actManag = 4;
        this.inputData[1].selectArr = [
          { label: "全部", id: null },
          { label: "幸运大抽奖", id: 8 },
        ];
      }
      if (this.$route.path.indexOf("activeList3") > 1) {
        this.actManag = 3;
        this.inputData[1].selectArr = [
          { label: "全部", id: null },
          { label: "疯狂捉娃娃", id: 23 },
          { label: "大家来找茬", id: 24 },
        ];
      }
    },
    extension(val) {
      this.CodeVisible = true;
      this.coodeItem.activityUrl = val.activityUrl;
      this.$nextTick(() => {
        this.$refs.qrcodebox.innerHTML = "";
        this.qrcodeAll(val.activityUrl, "qrcodebox");
      });
    },
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) this.recordData.status = "";
      if (i == 1) this.recordData.status = 2;
      if (i == 2) this.recordData.status = 1;
      if (i == 3) this.recordData.status = 3;
      this.queryList();
    },
    activityName(type) {
      let arr = ["", "签到赢好礼", "浏览礼品有礼", "每日抢好礼", "关注店铺有礼", "邀请开卡有礼", "邀请关注店铺有礼", "完善信息有礼", "幸运大抽奖"];
      let arr1 = [
        "开卡礼包",
        "店铺礼包",
        "店铺礼包（千人千面）",
        "下单有礼",
        "首购有礼",
        "复购有礼",
        "下单抽奖",
        "评价有礼",
        "裂变神券",
        "天降红包雨",
        "疯狂捉娃娃",
        "大家来找茬",
        "入会打榜",
        "幸运抽奖",
        "0元试用",
        "智能海报",
        "刮刮乐",
        "0元试用",
        "调查问卷",
        "生日有礼",
        "积分兑换",
        "满额有礼",
        "下单冲榜",
      ];
      let arr2 = ['会员升级礼']
      if(type == 37) return arr2[0];
      if (type < 9) return arr[type];
      if (type > 12) return arr1[type - 13];
     
    },
    //时间拼装
    time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      this.mytimestart = `${this.getDateStr(-30)} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteEvent(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.queryList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
    //结束确定
    handleDeleteTable() {
      let id = this.ids;
      endEvent(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("操作成功");
            this.outerVisible = false;
            this.queryList();
          }
        })
        .catch(() => {
          if (res.code == 10100) {
            this.$message.error("活动未开始不能结束活动");
            this.outerVisible = false;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    returnStep() {
      if (sessionStorage.getItem("goBack")) sessionStorage.removeItem("goBack");
      this.createStep = 1;
      this.recordData.current = 1;
      this.recordData.size = 10;
      // console.log(this.recordData,99988);
    },
    createActivity(type) {
      if (type == 5) {
        this.createStep = 5;
        this.activityData = {
          id: 4,
          name: "邀请开卡",
          telImg: require("../../assets/images/integralCenter/kk.jpg"),
          telCode: this.idUrl5,
        };
        return;
      }
      if (type == 16 || type == 17 || type == 18) {
        this.createStep = 16;
        switch (type) {
          case 16:
            this.activityData = {
              id: 16,
              name: "下单有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "下单有礼";
            break;
          case 17:
            this.activityData = {
              id: 17,
              name: "首购有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "首购有礼";
            break;
          case 18:
            this.activityData = {
              id: 18,
              name: "复购有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "复购有礼";
            break;
        }
        return;
      }
      if (type == 20 || type == 21 || type == 22) {
        this.createStep = 20;
        switch (type) {
          case 20:
            this.activityData = {
              id: 20,
              name: "评价有礼",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "评价有礼";
            break;
          case 21:
            this.activityData = {
              id: 21,
              name: "裂变神券",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "裂变神券";
            break;
          case 22:
            this.activityData = {
              id: 22,
              name: "天降红包雨",
              telImg: require("../../assets/images/integralCenter/dingzhi.png"),
              telCode: "",
            };
            this.titleName = "天降红包雨";
            break;
        }
        return;
      }
      if (type == 15) {
        this.createStep = 15;
        this.activityData = {
          id: 15,
          name: "店铺礼包千人千面",
          telImg: require("../../assets/images/integralCenter/dingzhi.png"),
          telCode: "",
        };
        this.titleName = "店铺礼包千人千面";
        return;
      }
      this.createStep = 2;
      switch (type) {
        case 1:
          this.activityData = {
            id: 1,
            name: "日历签到",
            telImg: require("../../assets/images/integralCenter/qdq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 3:
          this.activityData = {
            id: 2,
            name: "每日抢好礼",
            telImg: require("../../assets/images/integralCenter/mrq.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 4:
          this.activityData = {
            id: 3,
            name: "关注店铺有礼",
            telImg: require("../../assets/images/integralCenter/gzdp.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 5:
          this.activityData = {
            id: 4,
            name: "邀请开卡",
            telImg: require("../../assets/images/integralCenter/kk.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 6:
          this.activityData = {
            id: 5,
            name: "邀请关注店铺",
            telImg: require("../../assets/images/integralCenter/yqgz.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
        case 7:
          this.activityData = {
            id: 6,
            name: "完善信息有礼",
            telImg: require("../../assets/images/integralCenter/wsxx.jpg"),
            telCode: require("../../assets/images/integralCenter/code.png"),
          };
          break;
      }
    },
    returnBackChange() {
      this.createStep = 1;
      this.changeStatus();
    },
    saveEditChange() {
      this.createStep = 1;
      this.tabActive = 2;
      this.changeStatus();
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },
    //活动管理查询
    queryList() {
      this.talbeLoading = true;
      this.recordData.mainType = Number(this.actManag);
      this.talbeLoading = true;
      if (this.opentime == true) {
        this.opentime = false;
      }
      queryActivity(this.recordData)
        .then((res) => {
          this.talbeLoading = false;
          this.activityList = res.data.records;
          this.totalNum = Number(res.data.total);
        })
        .catch(() => {});
    },

    // 表单查询
    searchForm(form) {
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName;
      this.recordData.activityType = form.activityType;
      this.recordData.startTime = form.startTime;
      this.recordData.endTime = form.endTime;
      this.recordData.startUpdateTime = form.startUpdateTime;
      this.recordData.endUpdateTime = form.endUpdateTime;
      this.recordData.status = form.status;
      console.log("form:", this.recordData);
      this.queryList();
    },

    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.queryList();
    },

    //结束活动
    endenActivity(id) {
      // console.log(123);
      this.outerVisible = true;
      this.ids = id;
    },

    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    //修改

    modify(row, val, type = "edit") {
      console.log('活动类型------>', row)

      // type==edit 为修改
      this.backgroundOpacity = type == "look" ? true : false;
      // 进行中的活动  去掉保存按钮
      this.isCopy = type == "copy" ? true : false;

      // 活动进行中 可以修改 活动名称、活动结束时间、活动奖品数量（只可增加，不可减少）、活动规则、曝光商品
      console.log("val.status",val.status)
      if (val.status == 2 && type == "edit") {
        this.isStartEdit = true;
        this.isSave = true;
      }else if (val.status == 1) {
        this.isStartEdit = false;
        this.isSave = true;
      }else {
        this.isStartEdit = false;
        this.isSave = false;
      }
      console.log("this.isSave",this.isSave)
      // 评价有礼 修改禁用一些输入框
      this.statusComment = false;
      if (row == 20) {
        this.isSave = false;
        if (val.status == 2) {
          this.statusComment = false;
        } else {
          this.statusComment = true;
        }
      }
      let params = {
        activityData: {
          name: this.activityName(row),
          id: row > 1 && row < 8 ? row - 1 : row,
          telCode: "",
          goIndex: 3,
        },
        valueRow: {
          id: val.id,
        },
        statusComment: this.statusComment,
        isSave: this.isSave,
        isStartEdit:this.isStartEdit,
        backgroundOpacity: this.backgroundOpacity,
        activeValue: row,
        isCopy: this.isCopy,
        activityType: row > 1 && row < 8 ? row - 1 : row,
      };
      if (this.isCopy) {
        this.createStep = 2
        this.copyParams = params
        return 
      }
      if (row == 8) {
        this.$router.push({ path: "step", query: params });
      } else if (row == 19) {
        this.$router.push({ path: "step2", query: params });
      } else if (row == 23 || row == 24) {
        this.$router.push({ path: "games", query: params });
      } else if (row == 5) {
        this.$router.push({ path: "Invites", query: params });
      } else if (row == 16 || row == 17 || row == 18) {
        this.$router.push({ path: "polite", query: params });
      } else if (row == 20 || row == 21 || row == 22) {
        this.$router.push({ path: "evaluation", query: params });
      } else if(row == 25){
        this.$router.push({ path: "games", query: params });
      } else if(row == 26){
        this.$router.push({ path: "luckyDraw", query: params });
      } else if(row == 27){
        this.$router.push({ path: "trial", query: params });
      } else if(row == 31){
        this.$router.push({ path: "question", query: params });
      } else if(row == 32){
        this.$router.push({ path: "birthday", query: params });
      } else if(row == 33){
        this.$router.push({ path: "exchange", query: params });
      } else if(row == 34){
        this.$router.push({ path: "fulfilQuotaPage", query: params });
      } else if(row == 35){
        this.$router.push({ path: "orderRankPage", query: params });
      }else if(row == 37){
        this.$router.push({ path: "memberUpgrade", query: params });
      } else {
        this.$router.push({ path: "activity", query: params });
      }
    },
    changeStatus() {
      this.$emit("changeStatus");
    },
    //数据统计
    statisData(row) {
      this.rowData = row;
      console.log(row, "25896");
      this.ids1 = row.id;
      this.createStep = 3;
    },
    handleback(type) {
      this.$emit("goback", type);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabSwitch {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  // padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  &-wz {
    height: 50px;
    line-height: 50px;
    position: relative;
    margin-right: 24px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #2670fb;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      background-color: #2670fb;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.createbox {
  width: 94px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #2670fb;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  color: #fff;
  background-color: #2670fb;
  &:hover {
    opacity: 0.8;
  }
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.activityManage {
  box-sizing: border-box;
  padding: 24px;
  margin: 24px;
  background: #fff;
  .activityName {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    .code {
      cursor: pointer;
      font-size: 14px;
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .state {
    padding: 5px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #02b1ff;
    background: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      min-width: 28px;
      cursor: pointer;
    }
    .end,
    .edit,
    .count {
      cursor: pointer;
      color: #2670fb;
      &:hover {
        color: #2670fb;
      }
    }
    .delete {
      cursor: pointer;
      color: red;
      text-align: center;
      // &:hover {
      //   color: #2670fb;
      // }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
    &:active {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #2670fb;
    color: #ffffff;
    border-radius: 3px;
    background-color: #2670fb;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #2670fb;
    }
    &:active {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: #fff4f4;
    }
  }
}
.activityName_line {
  width: 95%;
  height: 0px;
  border-top: 1px solid #ccc;
  margin-top: 29px;
}
.activityName_title {
  background: #fff;
  padding: 10px 15px 10px 0;
  margin-top: -20px;
  font-size: 16px;
  width: 207px;
}
.activityName_bottom {
  width: 100%;
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
  flex-wrap: wrap;
  &_content {
    width: 48%;
    margin-bottom: 24px;
    background: #f8f9ff;
    display: flex;
    justify-content: space-between;
    padding: 15px 10px;
  }
  &_jc {
    background: #fff;
    border: 1px solid #dddddd;
    padding: 5px 8px;
    margin-left: 8px;
    cursor: pointer;
  }
  &_tg {
    background: #2670fb;
    color: #fff;
    border: 1px solid #2670fb;
    padding: 5px 8px;
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
